import { useSelector } from 'react-redux'
import { currentBotConfigurationSelector } from '@features/serverBots/selectors/currentBotConfigurationSelector'
import { getEnvironmentName } from '@features/serverBots/utils/getEnvironmentName'

export function useEnvironmentName(): string {
  const config = useSelector(currentBotConfigurationSelector)
  return getEnvironmentName(config)!
}
